import { SanmarPoItemDetails } from "./sanmar-po-item-details";

export class SanmarPoDetails {
    buyerPo: string;
    poDate: string;
    buyerAddress: string;
    shipToAdd: string;

    SanmarpoItemDetails: SanmarPoItemDetails[]
}